
'use strict';

export class Carousel {
    constructor(
        attr = "data-carousel", 
        options = {
          automatic: false,
          automaticTime: 6,
        }
    ) {
        this.attr = attr;
        this.options = options;
        this.container = document.querySelector(`[${this.attr}]`);
        this.itens = Array.from(this.container.children);
        this.btnPrev = this.container.previousElementSibling;
        this.btnNext = this.container.nextElementSibling;
        this.init();
    }
    get CSSClass() { return ["--display", "--show"] }
    get transition() { return "data-transition" }
    get duration() {
        const duration = getComputedStyle(this.itens[0]).transitionDuration;
        const seconds = duration.slice(0, -1);
        const milliseconds = seconds * 1000;

        return milliseconds;
    }
    get activeItem() {
        return this.itens.filter(item => item.classList.contains(this.CSSClass[0]))[0];
    }
    changeDesktop(change) {
        const time = (this.duration * 2) + 50;
        const previousItem = this.activeItem.previousElementSibling || this.itens[this.itens.length - 1]
        const nextItem = this.activeItem.nextElementSibling || this.itens[0];
        const show = (element) => {
            element.classList.add(this.CSSClass[0]);
            setTimeout(() => element.classList.add(this.CSSClass[1]), 20);
        }
        const hide = (element) => {
            element.classList.remove(this.CSSClass[1]);
            setTimeout(() => element.classList.remove(this.CSSClass[0]), this.duration);
        }

        if (!this.container.hasAttribute(this.transition)) {
            this.container.setAttribute(this.transition, "");
            hide(this.activeItem);
            if (change == "previous")
                setTimeout(() => show(previousItem), this.duration);
            else if (change == "next")
                setTimeout(() => show(nextItem), this.duration);
            else if (typeof change == "number") 
                setTimeout(() => show(this.itens[change]), this.duration);
                
            setTimeout(() => this.container.removeAttribute(this.transition), time);
        }
    }
    changeMobile(index) {
        const mobile = matchMedia("(max-width: 575.98px)").matches;
        const width = this.itens[index].clientWidth;

        if (mobile) this.container.scrollLeft = width * index;
    }
    arrows() {
        const btns = [this.btnPrev, this.btnNext];
        const change = ({ currentTarget: btn }) => {
            if (btn == this.btnPrev) 
                this.changeDesktop("previous");
            else
                this.changeDesktop("next");
        }
    
        btns.forEach(btn => btn.addEventListener("click", change));
    }
    dots() {
        const dots = Array.from(document.querySelectorAll(`[${this.attr}-dots] button`));
        const active = "--active";
        const update = (dot) => {
            dots.forEach(dot => dot.classList.remove(active));
            dot.classList.add(active)
        }
        const change = (dot, index) => {
            const notTransition = !this.container.hasAttribute(this.transition);
            const notActive = !dot.classList.contains(active);

            if (notTransition && notActive) {
                update(dot);
                this.changeDesktop(index);
                this.changeMobile(index);
            }
        }
        const watch = (entries) => {
            entries.forEach(({ isIntersecting, target }) => {
                if (isIntersecting) update(dots[this.itens.indexOf(target)]);
            });
        }
        const observer = new IntersectionObserver(watch, { threshold: 0.6 });

        this.itens.forEach(item => observer.observe(item));
        dots.forEach((dot, index) => dot.addEventListener("click", () => change(dot, index)));
    }
    automatic() {
        let automatic;
        const watch = () => {
            const seconds = this.options.automaticTime;
            const milliseconds = seconds * 1000;
            const change = () => {
                const activeIndex = this.itens.indexOf(this.activeItem);

                this.changeDesktop("next");
                this.changeMobile(activeIndex);
            }

            automatic = setInterval(change, milliseconds);
        }
        const observer = new IntersectionObserver(watch, { threshold: 0.6 });
        const start = () => observer.observe(this.container);
        const usability = () => {
            const eventsStop = ["mousedown", "touchstart"];
            const eventsStart = ["mouseup", "touchend"];
            const cancel = () => {
                clearInterval(automatic);
                observer.disconnect();
            }
            
            eventsStop.forEach(event => this.container.addEventListener(event, cancel));
            eventsStart.forEach(event => this.container.addEventListener(event, start));
        }

        start();
        usability();
    }
    init() {
        this.arrows();
        this.dots();
        if (this.options.automatic) this.automatic();
    }
}
